import { canUseDOM, cookie } from '@pmi/pmi-iqos-shared-react'

const noop = () => {}

export class DCXAnalyticsManager {
  constructor(dataLayer) {
    this.dataLayer = dataLayer || []
  }

  threeDSResult = success => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEvent',
      eventCategory: 'Checkout',
      eventLabel: `3D Secure - Payment ${success ? 'Success' : 'Failure'}`,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  searchInitiatedEvent = searchTerm => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'search_initiated',
      search: {
        search_term: searchTerm,
        search_location: 'navigation',
        page_name: 'home',
        page_category: 'home'
      }
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  searchResultClickEvent = (
    searchTerm,
    resultPosition,
    resultName,
    filtersApplied,
    pageNumber = 1
  ) => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'search_result_click',
      search: {
        search_term: searchTerm,
        result_position: resultPosition,
        result_name: resultName,
        filters_applied: filtersApplied,
        page_number: pageNumber
      }
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  searchResultsViewedEvent = (
    searchTerm,
    resultsCount,
    filtersApplied,
    pageNumber = 1
  ) => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'search_results_viewed',
      search: {
        search_term: searchTerm,
        results_count: resultsCount,
        filters_applied: filtersApplied,
        page_number: pageNumber
      }
    }

    dataLayer ? dataLayer.push(data) : noop()
  }
}
export default new DCXAnalyticsManager(canUseDOM ? window.dataLayer : null) // set by google tag manager
